<template>
  <div>
    <div class="title-name">{{label}} <span class="el-upload__tip"> <b class="red" v-if="tip">#</b>{{tip}}</span></div>
    <viewer ref="viewer" class="df upload-preview" :images="images">
      <div
        v-for="(item, index) in images"
        :key="item.src"
        class="images"
      >
        <i class="el-icon-error icon-action" @click="handleRemove(index)" />
        <div class="img-box">
          <img v-if="item.src" :src="item.src +'?x-oss-process=style/Q99'">
          <div class="mask">
            <i class="el-icon-zoom-in icon-action" @click="handlePreview(index)" />
          </div>
        </div>
        <div v-if="tag">
          <el-input
            v-model="item.text"
            type="textarea"
            rows="2"
            style="width: 148px;margin-top:8px"
            placeholder="图片备注"
          />
        </div>
      </div>
      <el-upload
        class="images"
        :file-list="images"
        :show-file-list="false"
        action="/api_file/upload.do/oss/upload"
        :accept="formatType"
        list-type="picture-card"
        :data="uploadConfig"
        :limit="limit"
        :before-upload="beforeUpload"
        :on-success="onSubmit"
        :on-exceed="handleOverLimit"
      >
        <i class="el-icon-plus" />
      </el-upload>
    </viewer>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'

Vue.use(Viewer, { debug: false })
export default {
  name: 'ImageUpload',
  componentName: 'ImageUpload',
  props: {
    code: {
      type: String,
      default: 'default'
    },
    tip: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    images: {
      type: Array,
      default: () => {
        return [{
          src: '',
          text: ''
        }]
      }
    },
    tag: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 30
    },
    sizeLimit: {
      type: Number,
      default: 3
    },
    fileType: {
      type: Array,
      default: () => {
        return ['*']
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    uploadConfig() {
      return { code: this.code }
    },
    formatType() {
      let str = ''
      this.fileType.forEach(element => {
        str += 'image/' + element + ','
      })
      return str
    }
  },
  methods: {
    // 提交
    onSubmit(response, file, fileList) {
      this.images.push({
        uid: file.uid,
        src: response.ossUrl || '',
        text: ''
      })
    },
    // 图片预览
    handlePreview(index) {
      const viewer = this.$refs['viewer'].$viewer
      viewer.view(index)
    },
    // 移除图片
    handleRemove(index) {
      this.images.splice(index, 1)
      this.$emit('update:images', this.images) // 直接修改父组件的属性
    },
    // 上传图片前校验
    beforeUpload(file) {
      const { sizeLimit } = this
      console.info(`上传限制 : ${sizeLimit} MB`)
      const isLt2M = file.size / 1024 / 1024 < sizeLimit

      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${sizeLimit} MB!`)
      }
      return isLt2M
    },
    // 超过数量限制
    handleOverLimit(files, fileList) {
      const { limit } = this
      this.$message.info(`上传图片数量超过 ${limit} 张的限制`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .tip {
    color: #A7AABD;
    font-size: 13px;
  }

  .upload-preview {
    flex-wrap: wrap;
  }

  .images {
    margin: 0 10px 10px 0;
    position: relative;
  }

  .img-box {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    position: relative;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .el-icon-error {
    position: absolute;
    right: -9px;
    top: -9px;
    color: #000;
    z-index: 3;
    font-size: 20px;
    cursor: pointer;
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .3);
    opacity: 0;
    transition: opacity .5s;
    color: #fff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon-action {
      // margin: 0 8px;
      cursor: pointer;
    }

    &:hover {
      opacity: 1;
    }
  }
</style>
